import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, errMsg } from "@/lib/api";

const KEY = ["cart"];

export const useCart = () => useQuery({ queryKey: KEY, queryFn: () => api.get("/cart").then((r) => r.data) });

export const useCartActions = () => {
  const qc = useQueryClient();
  const set = (data) => qc.setQueryData(KEY, data);
  const wrap = (fn) => async (...a) => { try { return await fn(...a); } catch (e) { throw new Error(errMsg(e)); } };
  const add = useMutation({ mutationFn: wrap((designId) => api.post("/cart/items", { design_id: designId }).then((r) => r.data)), onSuccess: (d) => set(d.cart) });
  const qty = useMutation({ mutationFn: wrap(({ id, quantity }) => api.put(`/cart/items/${id}`, { quantity }).then((r) => r.data)), onSuccess: set });
  const remove = useMutation({ mutationFn: wrap((id) => api.delete(`/cart/items/${id}`).then((r) => r.data)), onSuccess: set });
  return { add, qty, remove };
};
